export default "__VITE_ASSET__70f50449__"